import { Model } from '@/models/Model';

export class AttributeOption extends Model
{
  protected $name: string = 'AttributeOption';
  protected $endpoint: string = '/attribute-options';
  protected $fillable: string[] = ['title', 'attribute'];

  public title?: string;
  public id?: string;
  public attribute?: string;
}
